var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"name":_vm.name,"type":"hidden"},domProps:{"value":_vm.storeData.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }